<template>
  <div class="dropdown">
    <label>{{ label }}</label>
    <select @change='update'>
      <option
        v-for="value in values"
        :key="value.val"
        :value="value.val"
        :selected="value.val == selected"
      >{{value.text}}</option>
      </select>
  </div>
</template>

<script>
export default {
  name: "Selector",
  data() {
    return {};
  },
  props: {
    label: String,
    name: String,
    values: Array,
    selected: String
  },
  methods: {
    update(event) {
      let text = event.target.options[event.target.selectedIndex].label;
      this.$emit("update", {
        name: this.name,
        value: event.target.value,
        label: this.label,
        text
      });
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
</style>
